module.exports = __webpack_public_path__ + "static/noMessage.4b393840.png";